<svg class="MediaControlsIconPause" width="14" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 .245H0v16h4v-16zm10 0h-4v16h4v-16z" />
</svg>
